/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingSignupWorkflow
 */
export interface PendingSignupWorkflow {
    /**
     * 
     * @type {string}
     * @memberof PendingSignupWorkflow
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingSignupWorkflow
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof PendingSignupWorkflow
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof PendingSignupWorkflow
     */
    lastActivityDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PendingSignupWorkflow
     */
    daysToLive?: number;
}

/**
 * Check if a given object implements the PendingSignupWorkflow interface.
 */
export function instanceOfPendingSignupWorkflow(value: object): value is PendingSignupWorkflow {
    return true;
}

export function PendingSignupWorkflowFromJSON(json: any): PendingSignupWorkflow {
    return PendingSignupWorkflowFromJSONTyped(json, false);
}

export function PendingSignupWorkflowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingSignupWorkflow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'email': json['email'] == null ? undefined : json['email'],
        'lastActivityDate': json['lastActivityDate'] == null ? undefined : (new Date(json['lastActivityDate'])),
        'daysToLive': json['daysToLive'] == null ? undefined : json['daysToLive'],
    };
}

export function PendingSignupWorkflowToJSON(value?: PendingSignupWorkflow | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'accountId': value['accountId'],
        'email': value['email'],
        'lastActivityDate': value['lastActivityDate'] == null ? undefined : ((value['lastActivityDate']).toISOString().substring(0,10)),
        'daysToLive': value['daysToLive'],
    };
}

